export const styles = {
  container: "max-w-[1440px] w-full mx-auto px-[120px] flex flex-col items-center",
  headerWrapper: "flex flex-col items-center mt-[60px] space-y-3 text-center",
  transactionIdText: "text-[18px] font-medium text-gray-500 tracking-wide",
  payableAmountText: "text-[34px] font-semibold text-gray-900",
  subtitleText: "text-[16px] text-gray-600 mt-2",
  paymentOptionsWrapper: "flex justify-center mt-14 gap-12 flex-wrap",
  payButton:
    "w-[220px] h-[220px] bg-white border border-gray-200 rounded-xl flex flex-col gap-4 justify-center items-center cursor-pointer transition-all duration-200 hover:shadow-lg hover:border-gray-300 hover:-translate-y-1 active:scale-[0.98]",
  paymentLabelText: "text-[16px] font-medium text-gray-800",
  paymentLabelCentered: "text-[16px] font-medium text-gray-800 text-center",
};
